import { Form, Popover, Input } from 'antd';
import React, { useState } from 'react'
import { PlusOutlined, SmileOutlined } from '@ant-design/icons';
import Picker from 'emoji-picker-react';
import useEmojiInput from 'hooks/useEmojiInput';

const InputWithEmoji = ({ value, language, setValue, hideVarBTN, limit = 1024 }) => {
    const [showPicker, setShowPicker] = useState(false);
    const { inputRef: textareaRef, cursorPosRef, saveCursorPosition, insertAtCursor } = useEmojiInput();

    const handleAddVariable = () => {
        const el = textareaRef.current?.resizableTextArea?.textArea || textareaRef.current;
        const currentValue = el ? el.value : (value || '');

        // Extract existing variable numbers from the body
        const variableRegex = /{{(\d+)}}/g;
        const existingVariables = [];
        let match;

        // Collect existing variables from the body
        while ((match = variableRegex.exec(currentValue)) !== null) {
            existingVariables.push(parseInt(match[1], 10));
        }

        // Determine the next variable number
        const nextNumber = existingVariables.length === 0
            ? 1
            : Math.max(...existingVariables) + 1;

        const start = cursorPosRef.current.start ?? currentValue.length;
        const end = cursorPosRef.current.end ?? start;
        
        const textBefore = currentValue.slice(0, start);
        const textAfter = currentValue.slice(end);
        
        const needsLeadingSpace = start > 0 && !textBefore.endsWith(' ');
        const needsTrailingSpace = end < currentValue.length && !textAfter.startsWith(' ');
        
        const newVariable = `${needsLeadingSpace ? ' ' : ''}{{${nextNumber}}}${needsTrailingSpace ? ' ' : ''}`;
        const updatedBody = textBefore + newVariable + textAfter;

        if (updatedBody.length <= limit) {
            let reorderedIndex = 0;
            const reorderedBody = updatedBody.replace(variableRegex, () => {
                reorderedIndex++;
                return `{{${reorderedIndex}}}`;
            });

            setValue(reorderedBody);
            
            setTimeout(() => {
                if (el) {
                    el.selectionStart = el.selectionEnd = start + newVariable.length;
                    el.focus();
                }
            }, 0);
        }
    };

    const onEmojiClick = (emoji) => {
        if (value?.length >= limit) return;
        insertAtCursor(
            emoji.emoji,
            value,
            (newVal) => { if (newVal.length <= limit) setValue(newVal); }
        );
        setShowPicker(false);
    };

    const handleTextChange = (text) => {
        // Only update if text length is within limit
        if (text.length <= limit) {
            setValue(text);
        }
    };

    const emojiPickerContent = (
        <div style={{ maxWidth: '350px' }}>
            <Picker
                onEmojiClick={onEmojiClick}
                width="100%"
            />
        </div>
    );

    return (
        <Form.Item
            label="Body"
            name="Body"
            className='mb-0'
        >
            <Input.TextArea
                ref={textareaRef}
                rows={4}
                value={value}
                onChange={(e) => handleTextChange(e.target.value)}
                onBlur={saveCursorPosition}
                onSelect={saveCursorPosition}
                required
                spellCheck
                maxLength={limit}
            />
            <div className='d-flex align-items-center justify-content-end mt-1' style={{ gap: '10px' }}>
                <Popover
                    content={emojiPickerContent}
                    trigger="click"
                    open={showPicker}
                    onOpenChange={setShowPicker}
                    placement="left"
                    overlayStyle={{ zIndex: 1050 }}
                    overlayInnerStyle={{ padding: '8px' }}
                    getPopupContainer={(trigger) => trigger.parentElement}
                >
                    <SmileOutlined
                        style={{ cursor: 'pointer', fontSize: '18px' }}
                    />
                </Popover>
                <span>{value?.length}/{limit}</span>
                {!hideVarBTN &&
                    <div
                        style={{ background: '#eee', cursor: 'pointer' }}
                        className='p-2 rounded'
                        onClick={handleAddVariable}
                    >
                        <PlusOutlined />
                        <span className='ml-2'>Add variable</span>
                    </div>
                }
            </div>
            <span className='d-none'>{value}</span>
        </Form.Item>
    )
}

export default InputWithEmoji